<div class="layout py-12">
  <h2 class="font-bold text-4xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'hrPolicies' | translate }}
  </h2>
</div>
<div class="layout py-12 bg-beige">
  <h3 class="font-bold mb-9 text-3xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'hrPolicies.2.title' | translate }}
  </h3>
  <div class="flex flex-col md:flex-row gap-6 justify-center items-start">
    <div class="w-full md:basis-1/2 relative h-96">
      <img alt="" class="object-cover rounded-lg" fill="" loading="lazy"
           ngSrc="assets/images/rh/rh-8.webp">
    </div>
    <p [innerHtml]="'hrPolicies.2.description1' | translate"
       class="basis-full md:basis-1/2 font-medium text-gray-500 text-md whitespace-pre-line"></p>
  </div>
  <div class="flex flex-col md:flex-row gap-6 justify-center items-start mt-7">
    <div class="w-full aspect-[3/2] relative self-center order-last">
      <img alt="" class="object-cover rounded-lg" fill="" loading="lazy"
           ngSrc="assets/images/rh/rh-3.webp">
    </div>
    <div class="flex flex-col">
      <p class="mt-7 font-medium text-gray-500 text-md whitespace-pre-line">
        {{ 'commitment.description1' | translate }}
      </p>
      <a appHoverGradient
         class="big-btn py-4 text-md lg:col-start-2 col-span-3 lg:col-span-1 flex justify-center items-center gap-2"
         href="https://www.greatplacetowork.fr/workplace/item/8048/Calic%C3%A9o">
        {{ 'learnMore' | translate }}
      </a>
    </div>
  </div>
  <div class="relative mt-7">
    @if (page > 1) {
      <div class="absolute z-10 top-[85%] md:top-0 bottom-0 left-0 right-3/4 flex justify-center items-center">
        <div (click)="page = Math.max(1, page - 1)"
             (keyup.enter)="emulateClick($event)"
             class="p-1 rounded-full border border-gray-500 stroke-gray-500 hover:stroke-bleuCaliceo-400 hover:border-bleuCaliceo-400 cursor-pointer"
             tabindex="0">
          <svg aria-hidden="true" class="w-6 h-6" focusable="false" role="presentation"
               style="display: block; fill: none;stroke-width: 5.33333; overflow: visible;"
               viewBox="0 0 32 32">
            <path d="M20 28 8.7 16.7a1 1 0 0 1 0-1.4L20 4" fill="none"></path>
          </svg>
        </div>
      </div>
    }
    @if (page < 5) {
      <div class="absolute z-10 top-[85%] md:top-0 bottom-0 left-3/4 right-0 flex justify-center items-center">
        <div (click)="page = Math.min(5, page + 1)"
             (keyup.enter)="emulateClick($event)"
             class="p-1 rounded-full border border-gray-500 stroke-gray-500 hover:stroke-bleuCaliceo-400 hover:border-bleuCaliceo-400 cursor-pointer"
             tabindex="0">
          <svg aria-hidden="true" class="w-6 h-6" focusable="false" role="presentation"
               style="display: block; fill: none;stroke-width: 5.33333; overflow: visible;"
               viewBox="0 0 32 32">
            <path d="m12 4 11.3 11.3a1 1 0 0 1 0 1.4L12 28" fill="none"></path>
          </svg>
        </div>
      </div>
    }
    <ngx-extended-pdf-viewer [(page)]="page" [showBorders]="false" [showToolbar]="false" class="mt-7" height="460px"
                             pageViewMode="single" src="/assets/pdfs/gptw.pdf"
                             zoom="page-fit">
    </ngx-extended-pdf-viewer>
  </div>
</div>
<div class="layout py-12">
  <p class="font-medium text-gray-500 text-md whitespace-pre-line">
    {{ 'hrPolicies.step.title' | translate }}
  </p>
  <div class="flex flex-col md:flex-row gap-4 mt-4 md:mt-8 items-stretch">
    @for (step of steps; track step; let idx = $index) {
      <div class="basis-1/4 bg-bleuCaliceo-300 rounded-lg p-6 flex flex-col">
        <h3
          class="text-xl uppercase font-semibold text-white">{{ 'hrPolicies.step.' + step + '.title' | translate }}</h3>
        <p class="text-sm mt-3 text-white grow whitespace-pre-line">
          {{ 'hrPolicies.step.' + step + '.description' | translate }}
        </p>
      </div>
    }
  </div>
</div>
<div class="layout py-12 bg-beige">
  <h3 class="font-bold mb-9 text-3xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'hrPolicies.1.title' | translate }}
  </h3>
  <div class="flex flex-col md:flex-row gap-6 justify-center items-start">
    <div class="w-full md:basis-1/2 relative h-96">
      <img alt="" class="object-cover rounded-lg" fill="" loading="lazy"
           ngSrc="assets/images/rh/rh-9.webp">
    </div>
    <div class="basis-full md:basis-1/2">
      <p class="font-medium text-gray-500 text-md whitespace-pre-line">
        {{ 'hrPolicies.1.description1' | translate }}
        <br>
        <br>
        {{ 'hrPolicies.1.description2' | translate }}
      </p>
    </div>
  </div>
</div>
